import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.general.AllocationSettings.title',
    defaultMessage: 'Allocation settings',
    description: 'title of the allocations settings on the configuration page',
  },
  feedback: {
    allocationSettingsUpdated: {
      id: 'pages.settings.general.AllocationSettings.feedback.allocationSettingsUpdated',
      defaultMessage: 'Allocation settings saved',
      description: 'feedback on the successful update the allocation settings',
    },
    allocationSettingsNotUpdated: {
      id: 'pages.settings.general.AllocationSettings.feedback.allocationSettingsNotUpdated',
      defaultMessage: 'Allocation settings could not be saved',
      description: 'feedback on the failed update the allocation settings',
    },
  },
  display: {
    label: {
      id: 'properties.locations',
      defaultMessage: 'Locations',
      description: 'label of the locations display',
    },
  },
  editDrawer: {
    title: {
      id: 'pages.settings.general.AllocationSettings.editDrawer.title',
      defaultMessage: 'Edit allocation settings',
      description: 'title of the edit allocation settings drawer',
    },
    locationsArrayField: {
      label: {
        id: 'properties.locations',
        defaultMessage: 'Locations',
        description: 'label of the locations array field',
      },
    },
    locationField: {
      label: {
        id: 'properties.location',
        defaultMessage: 'Location',
        description: 'label of the location field',
      },
    },
    ordinalField: {
      label: {
        id: 'properties.ordinal',
        defaultMessage: 'Ordinal',
        description: 'label of the ordinal field',
      },
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'label of the edit button',
    },
  },
};

export default defineMessages(translations);
